import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Truck } from "../../../types";
import AvailabilityChart from "../../charts/AvailabilityChart";
import { ModalHeader } from "./ModalHeader";
import { VehicleSummary } from "./VehicleSummary";
import { VehicleHistoryTable } from "./VehicleHistoryTable";

interface VehicleDetailsModalProps {
  trucks: Truck[];
  registration: string;
  open: boolean;
  onClose: () => void;
  token?: string;
  updateEntryDirection: (truck: Truck, direction: "in" | "out") => void;
  updateTruck?: (truck: Truck) => void;
  updateLicensePlate?: (truck: Truck, newLicensePlate: string) => void;
  deleteTruck?: (truck: Truck) => void;
  groupedTrucks?: Record<string, Truck[]>;
}

export default function VehicleDetailsModal({
  trucks,
  registration,
  open,
  onClose,
  token,
  updateEntryDirection,
  updateTruck,
  updateLicensePlate,
  deleteTruck,
  groupedTrucks,
}: VehicleDetailsModalProps): React.JSX.Element {
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: 600,
        },
      }}
      onClose={onClose}
    >
      <ModalHeader registration={registration} onClose={onClose} />

      <DialogContent
        dividers
        sx={{ overflowY: "auto", overflowX: "hidden", maxHeight: "70vh" }}
      >
        <Box sx={{ mb: 2 }}>
          {/* Vehicle Summary Card */}
          <VehicleSummary trucks={trucks} registration={registration} />

          {/* Availability Chart Section */}
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                mb: 2,
                fontFamily: "SigmaSans",
                fontWeight: "bold",
                fontSize: "1.1rem",
              }}
            >
              Availability Timeline
            </Box>
            <AvailabilityChart trucks={trucks} registration={registration} />
          </Box>

          {/* Vehicle History Table Section */}
          <Box>
            <Box
              sx={{
                mb: 2,
                fontFamily: "SigmaSans",
                fontWeight: "bold",
                fontSize: "1.1rem",
              }}
            >
              Vehicle History
            </Box>
            <VehicleHistoryTable
              trucks={trucks}
              token={token}
              updateEntryDirection={updateEntryDirection}
              updateTruck={updateTruck}
              updateLicensePlate={updateLicensePlate}
              deleteTruck={deleteTruck}
              groupedTrucks={groupedTrucks}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ fontFamily: "SigmaSans" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
